<template>
  <component
    :is="tag"
    :disabled="disabled"
    :class="[
      'btn',
      sizeClasses,
      variantClasses,
      { 'cursor-not-allowed opacity-50': disabled },
      $attrs.class
    ]"
    v-bind="$attrs"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  variant?: 'primary' | 'secondary'
  size?: 'sm' | 'md' | 'lg'
  disabled?: boolean
  tag?: string
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'primary',
  size: 'md',
  disabled: false,
  tag: 'button',
})

const sizeClasses = computed(() => ({ sm: 'btn-sm', md: 'btn-md', lg: 'btn-lg' }[props.size]))
const variantClasses = computed(() => ({ primary: 'btn-primary', secondary: 'btn-secondary' }[props.variant]))
</script>
